<template>
  <div class="back card card-circle-chart" >
    <div class="card-header text-center">
      <h5 class="card-title color2">{{title}}</h5>
      <p class="description color2">{{description}}</p>
    </div>
    <div class="card-content">
      <div class="chart-circle" :data-percent="percentage" ref="chart">{{percentage}}%</div>
    </div>
    <div class="card-header text-center">
      <h3 class="card-title color2">{{avance}}/{{total}}</h3>
    </div>
  </div>
</template>
<script>
  export default{
    name: 'circle-chart-card',
    props: {
      color: {
        type: String,
        default: 'red'
      },
      percentage: {
        type: Number,
        default: 0
      },
      title: String,
      description: String,
      total:String,
      avance:String
    },
    data () {
      return {
        chartId: 'no-id',
        chart: null
      }
    },
    methods: {
      updateChartId () {
        var currentTime = new Date().getTime().toString()
        var randomInt = this.getRandomInt(0, currentTime)
        this.chartId = `div_${randomInt}`
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      renderChart (EasyPieChart) {
        /* eslint-disable no-new */
        this.chart = new EasyPieChart(this.$refs.chart, {
          lineWidth: 6,
          size: 160,
          scaleColor: false,
          trackColor: 'rgba(255,255,255,.25)',
          barColor: '#FFFFFF',
          animate: ({duration: 2000, enabled: true})
        })
      }
    },
    async mounted () {
      this.updateChartId()
      let EasyPieChart = await import('easy-pie-chart')
      this.renderChart(EasyPieChart)
    },
    watch: {
      percentage: function (newVal) {
        if (this.chart) {
          this.chart.update(newVal)
        }
      }
    }
  }
</script>
<style>
.color2{
  color: white !important;
}
.back{
  background-color: #50A6D3 !important;
  color:white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/CircleChartCard.vue